import React from "react";
import TeamCard from "./teamCard";
import { useTranslation } from "react-i18next";
import { teamMember1, teamMember2, teamMember3, teamMember4, teamMember5 } from "./data";

import { TeamContainer, TeamWrapper, TeamH1, TeamP } from "./teamElements";

const TeamSection = () => {
  const { t } = useTranslation();
  return (
    <TeamContainer id="team">
      <TeamH1>{t('teamTitle.txt')}</TeamH1>
      <TeamP> {t('teamP.txt')}</TeamP>
      <TeamWrapper>
        <TeamCard {...teamMember1} />
        <TeamCard {...teamMember2} />
        <TeamCard {...teamMember3} />
        <TeamCard {...teamMember4} />
        <TeamCard {...teamMember5} />
      </TeamWrapper>
    </TeamContainer>
  );
};

export default TeamSection;
